import React from 'react';
import MainEntrances from '../components/MainEntrances';

export default function TotalGames() {
  const entityType = 'total';

  return <MainEntrances entityType={entityType} />;
}
